export class ProvisionCalculationType {
  static Percent = 1;
  static Value = 2;
}
